module.exports = __webpack_public_path__ + "img/service_seats.5567f462.png";